import { Modal } from "antd";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { LOADING_URL } from "../../../constants/GeneralConstants";
import { CheckIcon } from "../../SvgComponents/CheckIcon/CheckIcon";

export const FormDataMissingModal = ({ open, onClose }) => {
    const { t } = useTranslation();

    const handleRestartFlow = () => {
        if (onClose) {
            onClose();
        }
        const baseUrl = window.location.origin;
        const url = localStorage.getItem(LOADING_URL);
        const link = baseUrl + "/loading" + url;
        window.top.location.href = link;
    };

    return (
        <Modal
            title={t("form_data_missing.title")}
            footer={null}
            open={open}
            closable={true}
            onCancel={onClose}
        >
            <div className="modal-container">
                <p className="nu-input-label">{t("form_data_missing.body")}</p>
                <p className="nu-input-label">{t("form_data_missing.action")}</p>
                <Col className="action-buttons mobile-button">
                    <Row>
                        <Col md={3} xs={3}></Col>
                        <Col md={6} xs={6}>
                            <button
                                type="button"
                                className="btn btn-primary btn-active"
                                onClick={handleRestartFlow}
                            >
                                <span className="cancel-text">{t("general.ok")}</span>
                                <CheckIcon />
                            </button>
                        </Col>
                        <Col md={3} xs={3}></Col>
                    </Row>
                </Col>
            </div>
        </Modal>
    );
};
